export enum UserStatus {
    ACTIVE = 'ACTIVE',
    BAN = 'BANNED',
    REPORT = 'REPORTED',
    PAYMENT = 'PAYMENTDUE',
    DELETED = 'DELETED'
}